import React from "react";
import "tippy.js/dist/tippy.css";
import IconButton from "./IconButton";
import { useTranslation } from 'react-i18next';

const AddButton = ({show = true, onClick, tooltip}) => {

    const { t } = useTranslation();

    return (
        <>
            <IconButton
                show={show}
                className={"mr-2"}
                variant="primary"
                onClick={onClick}
                fullIcon="fa-solid fa-plus"
                tooltip={tooltip || t("common.add")}
            />
        </>
    );
};


export default AddButton;